import type { ContractSchema } from '@libs/data-access/entities'
import type { UseAppQueryOptions } from '@libs/data-access/queries'
import { useQuery } from '@tanstack/react-query'

import type { FetchContractOptions } from '../contract.contract.api'
import { fetchContractById } from '../contract.contract.api'
import { contractQueryKeys } from '../contract.contract.cacheKeys'

export const useFetchOne = (
  request: FetchContractOptions,
  queryOptions?: UseAppQueryOptions<ContractSchema>
) =>
  useQuery({
    ...queryOptions,
    queryKey: contractQueryKeys.contract(request),
    queryFn: () => fetchContractById(request)
  })
